import { ChangeDetectionStrategy, Component, HostBinding, ViewChild, ViewEncapsulation } from "@angular/core";
import { MatLegacyDialogRef as MatDialogRef } from "@angular/material/legacy-dialog";
import { Store } from "@ngrx/store";
import { DialogLayoutComponent } from "@obg/mat.ui.core";
import { CORE_ROUTE, CoreState } from "@obg/ngx.core";
import { RouteAction } from "@obg/ngx.router";

@Component({
	selector: "obg-m-verification-dialog",
	styleUrls: ["./verification-dialog.container.scss"],
	templateUrl: "./verification-dialog.container.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class VerificationDialogContainer {
	@HostBinding("class.obg-m-verification-dialog") hostCssClass = true;
	@HostBinding("attr.test-id") testId = "verification-dialog-modal";
	@ViewChild("dialog") dialogLayout: DialogLayoutComponent | undefined;

	verificationRoute = CORE_ROUTE.verification.root;

	constructor(
		private store: Store<CoreState>,
		private dialogRef: MatDialogRef<VerificationDialogContainer>
	) {}

	onVerifyCustomerClick() {
		this.store.dispatch(RouteAction.navigate(CORE_ROUTE.verification.root));
		this.closeDialog();
	}

	closeDialog() {
		this.dialogRef.close();
	}
}
